import {
  ComponentBox,
  ComponentBoxHeaderFooter,
  ExportButton,
  LoadingSpinner,
  StateId,
  utils,
} from '@wallaby-ui/core';
import classNames from 'classnames';
import * as React from 'react';
import {useCallback, useState} from 'react';
import {defineMessages, injectIntl, WrappedComponentProps} from 'react-intl';

import styles from './ListWrapperBox.less';
import ExportLimitReachedContainer from 'src/js/containers/filter_and_search/components/ExportLimitReachedContainer';
import FetchedDataGridContainer from 'src/js/containers/grid/components/FetchedDataGridContainer';
import {GridReducerInjector} from 'src/js/containers/grid/components/GridReducerInjector';

const I18N = defineMessages({
  HELP: {
    id: 'grid.help',
    defaultMessage: 'This box is showing grid.',
    description: 'help text for grid box',
  },
  EXPORT: {
    id: 'common.export.button',
    defaultMessage: 'Export list',
    description: 'title text for export button',
  },
});

interface OwnProps {
  filterAndSearchStateId: StateId;
  handleExport?: () => void;
  isExportingCounter: number;
  gridId: string;
  serviceUrls?: any;
  caption?: string;
  exportDisabled?: boolean;
  helpText?: string;
  onGridInitialize: () => void;
}

type Props = OwnProps & WrappedComponentProps;

const ListWrapperBox: React.FC<Props> = (props) => {
  const {
    filterAndSearchStateId,
    handleExport,
    gridId,
    intl,
    isExportingCounter,
    serviceUrls,
    caption,
    exportDisabled = false,
    helpText,
    onGridInitialize,
  } = props;
  const titleText = caption
    ? utils.TranslateUtils.translate({id: caption}, intl)
    : '';
  const helpTitleText = helpText ? {id: helpText} : I18N.HELP;

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onLoadingChange = useCallback((newIsLoading: boolean) => {
    setIsLoading(newIsLoading);
  }, []);

  return (
    <div className={styles.dlListWrapperBox}>
      <div
        className={classNames(
          'dlLoadingSpinnerContainer',
          'dlFlexBoxContainerInContainer',
          {
            dlLoadingSpinnerParent: isLoading || isExportingCounter > 0,
          }
        )}
      >
        <LoadingSpinner isVisible={isLoading || isExportingCounter > 0} />
        <ExportLimitReachedContainer stateId={filterAndSearchStateId} />
        <ComponentBoxHeaderFooter
          helpText={utils.TranslateUtils.translate(helpTitleText, intl)}
          titleText={titleText}
        >
          <span className={styles.dlListWrapperBoxHeaderContent}>
            {handleExport && !exportDisabled && (
              <ExportButton
                onExport={handleExport}
                isDisabled={exportDisabled || isExportingCounter > 0}
                titleText={I18N.EXPORT.id}
              />
            )}
          </span>
        </ComponentBoxHeaderFooter>
        <ComponentBox>
          {/* Move into new Component */}
          <div className={styles.dlGeneratedLayout}>
            <div
              className={classNames({
                [styles.dlGeneratedLayoutComponent]: true,
              })}
            >
              <div className={styles.dlContent}>
                <GridReducerInjector gridId={gridId}>
                  <FetchedDataGridContainer
                    filterAndSearchStateId={filterAndSearchStateId}
                    configPath={serviceUrls.gridConfigConfigPath}
                    gridId={gridId}
                    apiUrl={serviceUrls.searchService}
                    onLoadingChange={onLoadingChange}
                    onGridInitialize={onGridInitialize}
                    showPageSize
                  />
                </GridReducerInjector>
              </div>
            </div>
          </div>
        </ComponentBox>
      </div>
    </div>
  );
};

ListWrapperBox.displayName = 'ListWrapperBox';

export default injectIntl(ListWrapperBox);
